import query from "./query";

export default `
  ${query}
`;
